<template>
 <div id="AdministrationFrequency">
     <h4 v-if="!this.$attrs.editMode" class="page-title text-truncate">{{$t('AdministrationFrequencySetup.AddAdministrationFrequency')}}</h4>
     <h4 v-else class="page-title text-truncate">{{$t('AdministrationFrequencySetup.EditAdministrationFrequency')}}</h4>

        <div class="page-height">      
            <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="isReadOnly">
               <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
               <div class="flex-grow-1">
                  <span>{{ $t('Shared.ReadOnlyPermission') }}</span>
               </div>
            </div>

            <div class="alert alert-fill-warning d-flex align-items-center m-3" role="alert" v-if="this.$attrs.editMode && FrequencyIsInUse">
                <i class="mdi mdi-alert-circle me-2" style="font-size: 1.5rem;"></i>
                <div class="flex-grow-1">            
                   {{ $t('AdministrationFrequencySetup.FreqIsInUse') }}
                </div>
            </div>

           
         <b-row>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.Code')"
                    v-bind:Name="'Code'"
                    v-bind:TypeProp="'text'"  
                    v-bind:MaxLengthProp="10"     
                    v-model="AFreq.code"
                    @blur="onCodeBlur"
                    v-bind:isReadOnly="isReadOnly || this.$attrs.editMode"
                    v-bind:Id="'input_AdmFreq_code'"
                    v-bind:isRequired="true"
                    v-bind:isValid="isCodeValid"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.Description')"
                    v-bind:Name="'Description'"
                    v-bind:TypeProp="'text'"  
                    v-bind:MaxLengthProp="50"         
                    v-model="AFreq.description"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:Id="'input__AdmFreq_description'"
                    v-bind:isRequired="true"
                    v-bind:isValid="isDescriptionValid"
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.ReEveryDays')"
                    v-bind:Name="'RecurEveryDays'"
                    v-bind:TypeProp="'number'"                      
                    v-model.number="AFreq.recurEveryDays"
                    v-bind:isReadOnly="isReadOnly || FrequencyIsInUse"
                    v-bind:Id="'input__AdmFreq_recurEveryDays'"                   
                /> 
            </b-col>
            <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('Shared.TimesPerDay')"
                    v-bind:Name="'TimesPerDay'"
                    v-bind:TypeProp="'number'"                      
                    v-model.number="AFreq.timesPerDay"
                    v-bind:isReadOnly="isReadOnly || FrequencyIsInUse"
                    v-bind:Id="'input__AdmFreq_TimesPerDay'"                   
                /> 
            </b-col>
           
         </b-row>

         <b-row>
             <b-col lg="3" md="3" sm="12">
                <MdEdit 
                    v-bind:Label="$t('AdministrationFrequencySetup.MinHoursBetweenDoses')"
                    v-bind:Name="'MinHoursBetweenDoses'"
                    v-bind:TypeProp="'number'"                      
                    v-model.number="AFreq.hoursBetweenDoses"
                    v-bind:isReadOnly="isReadOnly || FrequencyIsInUse"
                    v-on:change="ChangeMinHoursBetweenDoses"
                    v-bind:Id="'input__AdmFreq_MinHoursBetweenDoses'"                   
                /> 
            </b-col>
            <b-col md="auto mt-2">
                <MdCheckBox
                    v-bind:Label="$t('AdministrationFrequencySetup.MarsOnly')"
                    v-bind:Name="'ExcludeFromAdministration'"
                    v-bind:ClassProp="'AlignCheck'"
                    v-bind:CheckedValue="true"
                    v-bind:isReadOnly="isReadOnly || FrequencyIsInUse"
                    v-bind:UncheckedValue="false"
                    v-on:change="onChangeMars"
                    v-model="AFreq.excludeFromAdministration"/>
            </b-col>
            <b-col lg="3" md="3" sm="12" v-if="VisibleMode">
                <MdSelect
                    v-bind:Label="$t('Shared.Mode')"
                    v-bind:Options="ModeList"
                    v-bind:FieldDescription="'text'"
                    v-bind:FieldCode="'value'"
                    v-bind:AllowEmpty="false"
                    v-bind:Model="ModelMode"
                    v-bind:UseResetModel="true" 
                    v-bind:RequireEvent="true" 
                    v-bind:Tag="'AdminFreqMode'"
                    v-bind:IsDisabled="isReadOnly || FrequencyIsInUse"
                    v-bind:Multiple="false"              
                    :Input="ChangeDropDownMode"
                    />
            </b-col>            
         </b-row>


         <div id="ContainerTimeToAdminister" v-if="ModelMode.value === 'TIMED'">
            <MdTitle v-bind:Text="$t('AdministrationFrequencySetup.TimeToAdminister')" v-bind:isSubtitle="true" v-bind:Name="'T_TitleSearch'"/>

            <b-row>
                <div class="col-sm-12 col-md-3">                      
                        <MdButton
                        v-bind:Label="$t('AdministrationFrequencySetup.AddTime')" 
                        v-bind:ClassProp="isReadOnly ? 'btn btn-primary my-3 btn-block' : 'btn btn-primary my-3 btn-block btn-login'"
                        v-bind:IconClass="'ti-plus pr-1'"                    
                        v-on:click="CallModalTable"
                        v-bind:isReadOnly="isReadOnly || (items.length >= AFreq.timesPerDay)">
                        </MdButton>
                    </div>
                    <div class="col-sm-12 col-md-9 mb-4">                   
                        <div class="textlabel" :data-label="this.$t('Shared.SearchElements')">
                        <div class="input-group" dir="ltr">
                            <input 
                            type="text" 
                            class="form-control"
                            :dir="dirInput"
                            v-model="searchTime"   
                            @keyup.enter="FindTime">
                            <div class="input-group-append">
                                <div class="input-group-append">
                                <MdButton 
                                    v-bind:Name="'btnsearchinput'"
                                    v-bind:VariantProp="'btn btn-sm search-attached'"
                                    v-bind:IconClass="'mdi mdi-magnify'"
                                    v-on:click="FindTime">
                                </MdButton>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
            </b-row>

            <div class="row">
                <div class="col-md-12">
                    <MdTable 
                    v-bind:fields="Fields"
                    v-bind:items="items"
                    v-bind:totalRows="totalRows"
                    v-bind:isReadOnly="isReadOnly"
                    v-bind:showMessageIsEmpty="ShowMessageIsEmpty"
                    v-bind:currentPage="currentPage"
                    v-bind:perPage="perPage"
                    v-bind:pageOptions="pageOptions"
                    :onFiltered="onFiltered"                  
                    :pageChanged="pageChanged"                                 
                    :deleteIconEvent="RemoveTime"
                    :editIconEvent="EditTime"
                    v-bind:VisibleDeleteIcon="!FrequencyIsInUse"
                    v-bind:VisibleEditIcon="true"
                    :onRowSelected="onRowSelected"
                    :perPageFunction="PerPageFunction">
                    </MdTable>
                </div>
            </div>
        </div>




            <BaseModal 
                v-if="VisibleModalTime"
                ModalId="modalId"
                :HideModalFun="onHidden"
                :TitleWindow="$t('AdministrationFrequencySetup.ModalTime')"
                :width="'22%'"
                :height="'250px'"
                :UseScrollable="false"
                @ShownModal="ShownModal"
                :buttons="[
                    { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
                    { text: $t('Shared.TitleOK'), variant: 'primary', action: emitEventOK },                   
                ]"              
                @Close="onHidden"
                >
                <b-row>
                    <b-col lg="12" md="12" sm="12">
                        <MdSelect
                            v-bind:Label="$t('AdministrationFrequencySetup.ModalTime')"
                            v-bind:Options="TimeList"
                            v-bind:FieldDescription="'text'"
                            v-bind:FieldCode="'value'"
                            v-bind:AllowEmpty="false"
                            v-bind:Model="ModelTime"
                            v-bind:Multiple="false" 
                            v-bind:IsDisabled="isReadOnly"
                            v-bind:UseResetModel="true" 
                            v-bind:RequireEvent="true" 
                            v-bind:Tag="'AdminFreqTime'"           
                            :Input="ChangeDropDownTime"
                            />
                    </b-col>
                </b-row>
                
            </BaseModal>



            
             
        <div class="space-actions"></div>        
         <div class="page-actions">
               <MdButton
                  v-bind:Label="$t('Shared.Back')"
                  v-bind:Name="'btnpatientlist'"
                  v-bind:ClassProp="'secondary mx-2 btn-login'"
                  v-on:click="DiscardChanges"/>
            
               <MdButton
                  v-bind:Label="$t('Shared.Save')"
                  v-bind:ClassProp="isReadOnly ? 'primary mx-2':'primary btn-login mx-2'"
                  v-on:click="SaveOrEdit"
                  v-bind:isReadOnly="isReadOnly || !pendingChanges"
                  v-bind:Name="'btn_save_AdministrationFrequency'"/>
            </div>
      </div>



 </div>
</template>

<script>
import ShowMessage from '@/components/messages/ShowMessage.js';
import DrugFreqSetupHdrService from '@/services/drugfreqsetuphdrs.service';
import DBFunctions from '@/common/DBFunctions.js'
import Utils from "@/common/utils"
import { EventBus } from '@/event-bus.js';

export default {
       beforeRouteLeave(to, from, next) {
      if (!this.isReadOnly && this.pendingChanges) {
         this.$bvModal.msgBoxConfirm(this.$t('Msg.LeavingWithoutSaving'), {
            title: this.$t('Shared.Confirm'),
            okTitle: this.$t('Shared.BtnSave'),
            cancelTitle: this.$t('Shared.BtnDismiss'),
            footerClass: 'p-2',
            titleClass: 'modal-title modal-type-warning'
         })
            .then(value => {
               if(!value){
               next();
               } else {
                  this.SaveOrEdit();
                  next();
               }
            })		
      } else {
         next()
      }
    },

 name: 'AdministrationFrequency',
 mixins: [ShowMessage,DBFunctions],
  data(){
    return{
        isReadOnly:false,
        isCodeValid: true,
        isDescriptionValid:true,
        VisibleMode:true,
        pendingChanges: false,
        searchTime:"",
        TimeList:[
            {value:"12:01 am",text:"12:01 am"},
            {value:"01:00 am",text:"01:00 am"},
            {value:"02:00 am",text:"02:00 am"},
            {value:"03:00 am",text:"03:00 am"},
            {value:"04:00 am",text:"04:00 am"},
            {value:"05:00 am",text:"05:00 am"},
            {value:"06:00 am",text:"06:00 am"},
            {value:"07:00 am",text:"07:00 am"},
            {value:"08:00 am",text:"08:00 am"},
            {value:"09:00 am",text:"09:00 am"},
            {value:"10:00 am",text:"10:00 am"},
            {value:"11:00 am",text:"11:00 am"},
            {value:"12:00 pm",text:"12:00 pm"},
            {value:"01:00 pm",text:"01:00 pm"},
            {value:"02:00 pm",text:"02:00 pm"},
            {value:"03:00 pm",text:"03:00 pm"},
            {value:"04:00 pm",text:"04:00 pm"},
            {value:"05:00 pm",text:"05:00 pm"},
            {value:"06:00 pm",text:"06:00 pm"},
            {value:"07:00 pm",text:"07:00 pm"},
            {value:"08:00 pm",text:"08:00 pm"},
            {value:"09:00 pm",text:"09:00 pm"},
            {value:"10:00 pm",text:"10:00 pm"},
            {value:"11:00 pm",text:"11:00 pm"},
            {value:"11:59 pm",text:"11:59 pm"}
        ],
        ModelTime:{value:"",text:""},
        VisibleModalTime:false,
        ModelMode:{value:"TIMED",text:"Timed"},
        dirInput: this.$i18n.locale === 'ar' ? 'rtl' : 'ltr',
        ShowMessageIsEmpty:false,
        pageOptions: [5, 10, 15 ],
        totalRows: 0,
        currentPage: 1,
        FrequencyIsInUse:false,
        perPage: 10,
        filter: null,
        ModeModal:"",
        CodeExist: this.$attrs.editMode,
        filterOn: [],
        items: [], 
        RecId:"", 
        TimeSelected:{value:"",text:""},
        OptionsRightMenu:{
            visible:false,
            btnvisible:false,
            ItemsList:[],
            favButtonAtion: false
        },            
        ModeList:[           
            {value:"TIMED",text:"Timed"},
            {value:"PRN",text:"Prn"},
            {value:"STAT",text:"Stat"}
        ],
        AFreq:{
            code:"",
            description:"",
            recurEveryDays:1,
            timesPerDay:1,
            hoursBetweenDoses:null,
            excludeFromAdministration:false,
            mode:"TIMED",           
            timeList:[],
        },
        Fields: [
        { key: 'recNo', sortable: true, label: 'recNo', class: 'text-rigth hidden' },  
        { key: 'adminTime', sortable: true, label: 'Time', class: 'text-rigth' },                   
        ],
    }
  },

  methods:{
    ChangeMinHoursBetweenDoses(){
        if(this.AFreq.hoursBetweenDoses && this.AFreq.hoursBetweenDoses > 0){
            this.AFreq.timesPerDay = Math.round(24 / this.AFreq.hoursBetweenDoses);
        }
        
    },
    getUniqueID(){    
     return Math.floor(Date.now() / 1000);
    },
    onChangeMars(value){
        if(value){           
            this.VisibleMode = false;
            this.ModelMode = {value:"",text:""};
            this.AFreq.timeList = [];
            this.items = [];
        }else{
            this.VisibleMode = true;
            this.ModelMode = {value:"TIMED",text:"Timed"}; 
        }
    },
    ChangeDropDownTime(item){
        this.ModelTime = item;        
    },
    emitEventOK(){
        if(this.ModelTime.value === ""){
            this.showMessage(this.$tc('Msg.Error'),this.$tc('AdministrationFrequencySetup.ErrorAdminFreqTimeNoSelected'),"errorAutoHide"); 
        }else{ 
            if(this.ModeModal === "ADD"){          
                if(!this.items.some(x => x.adminTime === this.ModelTime.value)) {         
                    this.items.push({adminTime:this.ModelTime.value,recNo:this.getUniqueID()});
                    this.VisibleModalTime = false;
                    this.pendingChanges = true;
                }else{
                    this.showMessage(this.$tc('Msg.Error'),this.$tc('AdministrationFrequencySetup.ErrorAdminFreqSameTime'),"errorAutoHide"); 
                }  
            }else{
               this.items = this.items.map(x => x.recNo === this.RecId ? { ...x, adminTime: this.ModelTime.value }: x);
                this.pendingChanges = true;
                this.VisibleModalTime = false;
            }         
        }        
    },
    RemoveTime(item){
        this.items = this.items.filter(x => x.recNo !== item.recNo);
        this.pendingChanges = true;
    },

    EditTime(row){
        this.ModeModal = "EDIT";
        this.RecId = row.recNo;
        this.VisibleModalTime = true;
        this.TimeSelected.value = row.adminTime;
        this.TimeSelected.text = row.adminTime;
    },
    ShownModal(){
        if(this.ModeModal === "EDIT"){
            this.ModelTime = this.TimeSelected;
            EventBus.$emit('ChangedDrop', {model:this.ModelTime,Tag:"AdminFreqTime"}); 
        }
       
    },
    onFiltered(){

    },
    PerPageFunction(){

    },
    onHidden(){
        this.VisibleModalTime = false;
    },
    
    pageChanged(){

    },
    onRowSelected(){

    },
    DiscardChanges(){
        this.checkExistFavorite('/app/drugsadministrationfrequency');
        this.$router.push({ name: "drugsadministrationfrequency"}); 
    },

    ChangeDropDownMode(item){
        this.ModelMode = item;
        this.AFreq.mode = this.ModelMode.value;
        if(this.ModelMode.value === 'PRN' || this.ModelTime.value === 'STAT'){
            this.AFreq.timeList = [];
            this.items = [];
        }
    },
    FindTime(){

    },
    GoToList(){
        this.$router.push({ name: "drugsadministrationfrequency"}).catch(()=>{});
    },
    CallModalTable(){
       // EventBus.$emit('OnResetModelSelect'); 
        this.ModelTime = {value:"",text:""};
        this.VisibleModalTime = true;
        this.ModeModal = "ADD";
    },

    convertTo24h(time) {
        let [hour, minute] = time.match(/\d+:\d+/)[0].split(":").map(Number);
        const isPM = /pm/i.test(time);
        const isAM = /am/i.test(time);

        if (isPM && hour < 12) hour += 12;
        if (isAM && hour === 12) hour = 0;

        return `${hour.toString().padStart(2,'0')}:${minute.toString().padStart(2,'0')}`;
    },

    PrepareData(){
        this.AFreq.timeList = [];
        this.items.forEach(element => {           
           this.AFreq.timeList.push({
                adminTime: "1899-12-30T" + this.convertTo24h(element.adminTime),
                recNo:element.recNo
            });
        });
    },

    onCodeBlur(value) {
           // setTimeout(() => {
                if (!this.$attrs.editMode) {           
                    if (value.trim()!== '') {
                        DrugFreqSetupHdrService.ExistCode(value.trim())
                            .then((response) => {
                                if(response.status == '200'){
                                    this.CodeExist = response.data;
                                    if(this.CodeExist){
                                        this.isCodeValid = false;
                                        this.showMessage(this.$tc('Msg.Error'),this.$t('AdministrationFrequencySetup.AdminFreqCodeExist'),"error");                                        
                                    } 
                                }                    
                            })
                            .catch((error) => {
                                this.showResponseErrorMessage(error);           
                            });  
                    }
                }
           // }, 300);
        },

    SaveOrEdit(){
         if (this.validate_required()) {               
            this.PrepareData();
            this.$attrs.editMode ? this.UpdateAdminFreq() : this.AddAdminFreq();
        } else {
            this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.CheckRedLabeledFields'), "errorAutoHide");          
        }       
    },

    async AddAdminFreq(){  
          if(!this.CodeExist){
            await DrugFreqSetupHdrService
            .add(this.AFreq).then((response) => {      
                if (response.status == '200') { 
                    this.pendingChanges = false; 
                    this.GoToList();                   
                setTimeout(() => 
                    this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                        title: this.$t('Msg.Success'),
                        autoHideDelay: 5000,
                        variant: "success"
                    })
                    , 50); 
                }                     
            })
            .catch(error => {                
                this.showResponseErrorMessage(error);
            }); 
        }else{
            this.showMessage(this.$tc('Msg.Error'),this.$t('AdministrationFrequencySetup.AdminFreqCodeExist'),"error");
        } 
    },

    async getAdminFreq(){  
         await DrugFreqSetupHdrService
          .get(this.$route.params.id).then((response) => {      
              if(response.status == '200' && response.data) {                    
                this.AFreq = response.data;
                var TimeList = this.AFreq.timeList;

                if(this.AFreq.mode === "TIMED"){
                    this.ModelMode.value = "TIMED";
                    this.ModelMode.text = "Timed";                    
                }else if(this.AFreq.mode === "PRN"){
                    this.ModelMode.value = "PRN";
                    this.ModelMode.text = "Prn";
                }
                else{
                    this.ModelMode.value = "STAT";
                    this.ModelMode.text = "Stat";                     
                }              

                TimeList.forEach(element => {
                   element.adminTime = Utils.formatTime4(element.adminTime); 
                });

                this.items = [...TimeList];
              }                     
          })
          .catch(error => {                
            this.showResponseErrorMessage(error);
          });  
    },

    async UpdateAdminFreq(){
        //if(!this.FrequencyIsInUse){
             await DrugFreqSetupHdrService
          .update(this.$route.params.id,this.AFreq).then((response) => {      
              if(response.status == '200') { 
                this.pendingChanges = false; 
                this.GoToList();                   
               setTimeout(() => 
                this.$bvToast.toast(this.$t('Shared.SavedSuccessfully'), {
                    title: this.$t('Msg.Success'),
                    autoHideDelay: 5000,
                    variant: "success"
                })
                , 50); 
              }                     
          })
          .catch(error => {                
            this.showResponseErrorMessage(error);
          });
        /*}else{
          this.showMessage(this.$tc('Msg.Error'),this.$tc('AdministrationFrequencySetup.FreqIsInUseSave'),"errorAutoHide");   
        }*/
           
    },

    validate_required() {  

        this.isCodeValid = !Utils.isNullOrEmptyString(this.AFreq.code);
   
        this.isDescriptionValid = !Utils.isNullOrEmptyString(this.AFreq.description);           
        return this.isCodeValid && this.isDescriptionValid;
    },

    async FreqIsInUse(){
          await DrugFreqSetupHdrService
          .FrequencyIsInUse(this.$route.params.id).then((response) => {      
              if(response.status == '200') { 
                this.FrequencyIsInUse = response.data; 
              }                     
          })
          .catch(error => {                
            this.showResponseErrorMessage(error);
          });  
    }
  },

  async mounted(){
    this.OptionsRightMenu.visible = false;
    this.OptionsRightMenu.btnDrugOrdersInboxvisible = false;    
    this.OptionsRightMenu.ItemsList = [];
    this.$emit('onMenuRightBarDrugOrdersInbox', this.OptionsRightMenu);
    let layoutStatus = this.$store.state.layoutStatus;
    switch(layoutStatus) {
    case 'L0R1':
        this.OptionsRightMenu.favButtonAtion = true;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    break;
    case 'L1R0':
    case 'L1R1':
        this.OptionsRightMenu.btnvisible = false;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    break;
    default:
        this.OptionsRightMenu.favButtonAtion = true;
        this.$emit('getVisibleMenu', this.OptionsRightMenu);
    } 
    if(this.$attrs.editMode){
        await this.FreqIsInUse();
        this.getAdminFreq();
    }

    EventBus.$on("onChanged", (e) => {       
        this.pendingChanges = e.Changed; 
    })
  }
   
};
</script>


